import React from 'react';
import { motion } from 'framer-motion';

// Fades content up into place the first time it scrolls into view.
const Reveal = ({ children, delay = 0, className, as = 'div', id }) => {
  const Component = motion[as];
  return (
    <Component
      id={id}
      className={className}
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-60px' }}
      transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </Component>
  );
};

export default Reveal;
